import { PaymentHistoryItemStatus } from '@clearverify/constants';
export const formatPaymentHistoryItemStatus = (status, isRefunded) => {
    switch (status) {
        case PaymentHistoryItemStatus.Failed:
            return 'Failed';
        case PaymentHistoryItemStatus.Pending:
            return 'Pending';
        case PaymentHistoryItemStatus.Succeeded:
            if (isRefunded) {
                return 'Refunded';
            }
            return 'Succeeded';
        default:
            return 'Failed';
    }
};
//# sourceMappingURL=billing.js.map